import { useState, useCallback, useMemo, ChangeEvent } from "react";
import { useSearchParams } from "react-router-dom";
import { Stack, TextField, IconButton } from "@mui/material";
import { Clear, Search } from "@mui/icons-material";

interface Props {
  name: string;
  label: string;
}
const SearchById = ({ name, label }: Props) => {
  const [params, setSearchParams] = useSearchParams();
  const [patientId, setPatientId] = useState(params.get(name) ?? "");
  const handleChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    setPatientId(event.target.value);
  }, []);

  const handleClear = useCallback(() => {
    params.delete(name);
    setSearchParams(params);
    setPatientId("");
  }, [name, params, setSearchParams]);

  const handleSearch = useCallback(() => {
    params.set(name, patientId);
    setSearchParams(params);
  }, [name, params, patientId, setSearchParams]);

  const showClear = useMemo(() => {
    return params.has(name);
  }, [name, params]);

  return (
    <Stack direction="row" position="relative">
      <TextField
        size="small"
        label={label}
        value={patientId}
        onChange={handleChange}
      />
      {showClear ? (
        <IconButton
          onClick={handleClear}
          sx={{
            position: "absolute",
            right: "0",
          }}
        >
          <Clear />
        </IconButton>
      ) : (
        <IconButton
          onClick={handleSearch}
          sx={{
            position: "absolute",
            right: "0",
          }}
        >
          <Search
            sx={{
              "&:hover": {
                borderRadius: 8,
              },
            }}
          />
        </IconButton>
      )}
    </Stack>
  );
};

export default SearchById;
